export default {
  type: 'layoutRows',
  shadow: '@theme:card.shadow',
  fontName: '@theme:card.fontName',
  rounded: '@theme:card.rounded',
  bgColor: 'white',
  hover: 'light-7',
  border: true,
  padding: '0',
  fontSize: '3',
  showJourneyType: true,
  showTravelClass: true,
  fareItemOriginDestination: {
    showOriginAirportCode: false,
    showDestinationAirportCode: false,
    showOrigin: false,
    showOriginLabel: false,
    showDestinationLabel: false,
    showSeparator: false,
    showLineSeparator: true,
    fontSize: '4',
    marginTop: '2',
    textTransform: 'capitalize',
    style: {
      lineHeight: '1',
    },
    destinationCityStyles: {
      fontWeight: 'bold',
      marginBottom: 1,
    },
    destinationLabelStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    originAirportCodeStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    destinationAirportCodeStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    lineSeparatorStyles: {
      marginBottom: '1',
    },
  },
  showRoute: false,
  fareItemRoute: {
    fontWeight: 'bold',
    fontSize: '4',
    paddingBottom: '1',
    separatorLabel: {
      content: 'minus',
    },
  },
  showDepartureInfo: false,
  fareItemDepartureInfo: {
    showDepartureText: false,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: false,
  fareItemReturnInfo: {
    showReturnText: false,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  showOriginDestinationImage: true,
  fareItemOriginDestinationImage: {
    heightDestinationImage: 100,
    widthDestinationImage: 100,
    roundedCircle: true,
  },
  showPrice: true,
  fareItemDepartureReturn: {
    marginBottom: '1',
  },
  fareItemJourneyType: {
    fontSize: '14px',
    fontWeight: 'normal',
    textColor: 'dark',
  },
  separatorJourneyTypeProps: {
    fontSize: '14px',
    content: '/',
    fontWeight: 'normal',
    textColor: 'dark',
  },
  fareItemTravelClass: {
    fontSize: '14px',
    fontWeight: 'normal',
    textColor: 'dark',
  },
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    fontSize: '5',
    textAlign: 'left',
    fontWeight: 'bold',
    textColor: 'primary',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    marginTop: '2',
    style: {
      lineHeight: 1,
    },
    pricePromoStyles: {
      fontWeight: 'normal',
      fontSize: '15px',
      textTransform: 'lowercase',
      marginRight: '2',
      textColor: 'dark',
    },
  },
  fareImageContainer: {
    margin: 'auto',
  },
  fareImageItem: {
    grow: '2',
    paddingHeight: '3',
    paddingLeft: '2',
  },
  fareContentItem: {
    grow: '5',
    padding: '2',
  },
  fareFooterItem: {
    alignItems: 'end',
  },
  showDurationTrip: false,
  showLastSeen: false,
  fareItemLastSeen: {},
  showCallToAction: false,
  fareItemCallToAction: {},
};
